import { FileText, ExternalLink } from '../../../icons';
import { tSettings } from '../../../lib/settings-i18n';
import { tOss } from '../../../lib/oss-i18n';

/**
 * 약관 및 서비스 정책 (2026-08-20 하위 메뉴 분리) — 원래 `AccountPanel` 뒤쪽 블록.
 *
 * 이용약관·개인정보 처리방침은 아직 본문이 없어 자리만 둔다. 오픈소스 고지는 이미 있는 공개
 * 라우트(`/oss-licenses`)라 실제로 연결한다 — 앱 셸 밖 단독 페이지여서 새 탭으로 연다
 * (설정 창을 잃지 않게). 내용·동작 모두 옮기기만 했다.
 */
export function PolicyPanel() {
  return (
    <section className="settings-section" aria-labelledby="st-policy-h2">
      <h2 id="st-policy-h2">{tSettings('settings.modal.policy.heading')}</h2>
      <p className="settings-section-subtitle">{tSettings('settings.modal.policy.desc')}</p>

      <div className="st-linklist">
        <span className="st-link st-link--pending">
          <FileText size={15} aria-hidden />
          <span className="st-link__label">{tSettings('settings.modal.policy.terms')}</span>
          <span className="st-badge">{tSettings('settings.modal.pending_badge')}</span>
        </span>
        <span className="st-link st-link--pending">
          <FileText size={15} aria-hidden />
          <span className="st-link__label">{tSettings('settings.modal.policy.privacy')}</span>
          <span className="st-badge">{tSettings('settings.modal.pending_badge')}</span>
        </span>
        <a className="st-link" href="/oss-licenses" target="_blank" rel="noopener noreferrer">
          <FileText size={15} aria-hidden />
          <span className="st-link__label">{tSettings('settings.modal.policy.oss')}</span>
          <span className="st-link__hint">{tOss('oss.link')}</span>
          <ExternalLink size={13} aria-hidden />
        </a>
      </div>
    </section>
  );
}
